/**
 * Store admin — sample detail (Commerce, M3).
 *
 * @see apps/web/src/features/store/samples/sample-detail-page.tsx
 */
import { createFileRoute } from "@tanstack/react-router";
import { SampleDetailPage } from "../../../../../../features/store/samples/sample-detail-page.tsx";

export const Route = createFileRoute("/(workspace)/store/admin/sampling/$sampleId/")({
  component: RouteComponent,
});

function RouteComponent() {
  const { sampleId } = Route.useParams();
  return <SampleDetailPage sampleId={sampleId} />;
}
